<ng-container>
  @if (serviceCategories() && solutionCategories()) {
    <div class="front-footer-container">
      <div [contentFlex]="'content'" [row]="'computer'">
        <div [contentFlex]="'content'" [col]="'12|3-computer'">
          <h4 class="front-footer-slogan" [title]="'Umbrella SIE slogan' | trans">
            {{ 'Umbrella SIE slogan' | trans }}
          </h4>
        </div>

        <div [contentFlex]="'content'" [col]="'12|9-computer'" [row]="'tablet'">
          <div
            [contentFlex]="'content'"
            [col]="'12|4-computer'"
            class="front-footer-menu-container"
          >
            <h5 [title]="'Menu' | trans" class="front-footer-menu-title">
              {{ 'Menu' | trans }}
            </h5>

            <ul class="front-footer-menu-items">
              <li [title]="'Home' | trans" class="front-footer-menu-item">
                <a
                  class="front-footer-menu-item-nav"
                  [routerLink]="['/home']"
                  [routerLinkActive]="'selected-item'"
                >
                  {{ 'Home' | trans }}
                </a>
              </li>

              <li [title]="'RSE' | trans" class="front-footer-menu-item">
                <a
                  class="front-footer-menu-item-nav"
                  [routerLink]="['/rse']"
                  [routerLinkActive]="'selected-item'"
                >
                  {{ 'RSE' | trans }}
                </a>
              </li>

              <li [title]="'Blog' | trans" class="front-footer-menu-item">
                <a
                  class="front-footer-menu-item-nav"
                  [routerLink]="['/blog']"
                  [routerLinkActive]="'selected-item'"
                >
                  {{ 'Blog' | trans }}
                </a>
              </li>

              <li [title]="'Contact' | trans" class="front-footer-menu-item">
                <a
                  class="front-footer-menu-item-nav"
                  [routerLink]="['/contact']"
                  [routerLinkActive]="'selected-item'"
                >
                  {{ 'Contact' | trans }}
                </a>
              </li>
            </ul>
          </div>

          <div
            [contentFlex]="'content'"
            [col]="'12|4-computer'"
            class="front-footer-menu-container"
            [class.has-not-items]="serviceCategories().length === 0"
          >
            <h5 [title]="'Services' | trans" class="front-footer-menu-title">
              {{ 'Services' | trans }}
            </h5>

            <ul class="front-footer-menu-items">
              @for (serviceCategory of serviceCategories(); track $index) {
                <li
                  [title]="serviceCategory.title | trans"
                  class="front-footer-menu-item"
                >
                  <a
                    class="front-footer-menu-item-nav"
                    [routerLink]="['/services', serviceCategory.slug]"
                    [routerLinkActive]="'selected-item'"
                  >
                    {{ serviceCategory.title | trans }}
                  </a>
                </li>
              }
            </ul>
          </div>

          <div
            [contentFlex]="'content'"
            [col]="'12|4-computer'"
            class="front-footer-menu-container"
            [class.has-not-items]="solutionCategories().length === 0"
          >
            <h5 [title]="'Solutions' | trans" class="front-footer-menu-title">
              {{ 'Solutions' | trans }}
            </h5>

            <ul class="front-footer-menu-items">
              @for (solutionCategory of solutionCategories(); track $index) {
                <li
                  [title]="solutionCategory.title | trans"
                  class="front-footer-menu-item"
                >
                  <a
                    class="front-footer-menu-item-nav"
                    [routerLink]="['/solutions', solutionCategory.slug]"
                    [routerLinkActive]="'selected-item'"
                  >
                    {{ solutionCategory.title | trans }}
                  </a>
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
    </div>
  }
</ng-container>
